module.exports = __webpack_public_path__ + "img/gy.613e758f.png";